import { dialog } from "nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import { formatDate } from "../../../components/common/Converter";
import ExportCSVFunction from "../../../components/ExportCSVFunction";

class JobApplicantsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [
      "positionTitle",
      "positionTitle.salaryPointer",
      "positionApplied",
    ];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    // this.keys = [
    //   "reference",
    //   "surname",
    //   "Firstname",
    //   "Middlename",
    //   "email",
    //   "created",
    //   "status",
    //   "positionTitle.position_title",
    //   "publication",
    //   "reposting",
    //   "typeOfApplicant",
    //   "placeOfOrigin",
    //   "placeOfAssignment",
    //   "createdAt",
    // ];
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    console.log("QURE: ", query);
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      const totalObject = await this.findObjectUseCase.execute(collection, {
        where: query.where,
        keys: ["id"],
      });
      this.view.setState({ totalObject: totalObject.length });
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  onChangeFilter = (type, value, field) => {
    // Copy the current filters from the state
    const where = { ...this.view.state.filters };

    // Apply the new filter
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      case "Boolean":
        if (value !== null) {
          where[field] = value;
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      default:
        if (value) {
          where[field] = { $regex: value, $options: "i" };
        } else {
          delete where[field]; // Remove filter if no value
        }
    }
    console.log("where: ", this.view.state.filters);
    this.view.setState({ filters: where }, () => {
      this.filterSubmit(this.view.state.filters);
    });
  };

  async getGenerateXLSX(schema) {
    this.view.setState({ isGenerating: true });
    const keys = [
      "reference",
      "status",
      "positionTitle.position_title",
      "placeOfAssignment",
      "placeOfOrigin",
      "residentialAddress",
      "permanentAddress",
      "Firstname",
      "Middlename",
      "surname",
      "sex",
      "email",
      "mobile",
      "createdAt",
      "recidentialCity",
      "recidentialProvince",
      "recidentialBrangay",
      "permanentCity",
      "permanentProvince",
      "permanentBrangay",
    ];
    const query = this.createQuery();
    query.keys = keys;
    delete query.limit;
    try {
      const objects = await this.findObjectUseCase.execute(
        this.view.getCollectionName(),
        query,
      );

      schema.fields.residentialAddress = {
        type: "String",
      };
      schema.fields.permanentAddress = {
        type: "String",
      };
      schema.fields.position = {
        type: "Object",
      };
      schema.fields.createdAt = {
        type: "Date",
        label: "Date Applied",
      };
      schema.fields.surname = {
        type: "String",
        label: "Last name",
      };

      objects.forEach((object) => {
        object.residentialAddress = [
          object?.recidentialCity,
          object?.recidentialProvince,
          object?.recidentialBrangay,
        ].join(", ");
        object.permanentAddress = [
          object?.permanentCity,
          object?.permanentProvince,
          object?.permanentBrangay,
        ].join(", ");
        object.position = object?.positionTitle;
        object.createdAt = new Date(object.createdAt).toLocaleDateString(
          "en-US",
          {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          },
        );
      });
      // console.log("OBEJCTG: ", objects);
      // return;

      const fields = [
        "reference",
        "status",
        "position",
        "placeOfAssignment",
        "placeOfOrigin",
        "residentialAddress",
        "permanentAddress",
        "surname",
        "Firstname",
        "Middlename",
        "sex",
        "email",
        "mobile",
        "createdAt",
      ];

      ExportCSVFunction(objects, "Applicants", schema, fields);
    } catch (e) {
      console.error(e.message || e);
    } finally {
      this.view.setState({ isGenerating: false });
      dialog.close();
    }
  }
}
export default JobApplicantsPresenter;
